import gql from 'graphql-tag'
import { GenerationFragment } from '@/graphql/fragments/vehicle'

export const mutation = gql`
  ${GenerationFragment}
  mutation updateGeneration($id: Int!, $fields: vehicle_generation_set_input!) {
    record: update_vehicle_generation_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...Generation
    }
  }
`

export default mutation
